import type {
  BaseParams,
  ErrorUserData,
  UserParams,
} from '@wix/panorama-common-shared/types';
import { ErrorMonitorPluginParams, PluginParams } from './plugins';

export interface FactoryOptions {
  baseParams?: BaseParams;
  data?: UserParams['data'];
}

export interface ClientOptions {
  baseParams?: BaseParams;
  pluginParams?: PluginParams;
  data?: UserParams['data'];
}

export interface TransactionOptions {
  id?: number | string;
}

export type ErrorMonitorUserData = ErrorUserData &
  Pick<ErrorData, 'exceptionType'>;

export type ErrorMonitorUserDataForComponent = ErrorUserData;

export interface ErrorMonitorOptions {
  pluginParams?: ErrorMonitorPluginParams;
  data?: ErrorUserData;
}

export interface ErrorMonitorOptionsForComponent {
  data?: ErrorUserData;
}

export interface Breadcrumb {
  message: string;
}

export interface ErrorData {
  exceptionType?: ExceptionType;
}

export enum ExceptionType {
  HANDLED = 'HANDLED',
  UNHANDLED = 'UNHANDLED',
}

export enum StacktraceScriptType {
  WIX_SERVICE = 'WIX_SERVICE',
  WIX_APP = 'WIX_APP',
  WIX_CLI_APP = 'WIX_CLI_APP',
  WIX_CHAT = 'WIX_CHAT_WIDGET',
  BROWSER_EXTENSION = 'BROWSER_EXTENSION',
}

export interface ArtifactData {
  artifactId: string;
  artifactVersion: string;
  scriptType: StacktraceScriptType;
}

export interface WixHttpErrorDetails {
  isWixHttpError?: boolean;
  requestId?: string;
}

export interface StackFrame {
  filename?: string;
  raw?: string;
  module_metadata?: any;
}
